<template>
  <div
    layout="column"
    layout-align="start start"
    class="mb-6 mt-2"
  >
    <div
      v-if="evaluations && evaluations.length"
      layout-gt-md="row"
      layout-align="start stretch"
      layout-wrap
      style="width: 100%"
    >
      <v-card
        v-for="e in evaluations"
        :key="e.id"
        class="card-a-puce ml-2 mr-2"
      >
        <v-card-title
          primary-title
          class="headline font-weight-bold eval-title"
        >
          <div class="name">
            {{ e.trainer ? e.trainer.firstname + " " + e.trainer.lastname : e.created_by }}<span v-if="e.session.application == Consts.APPLICATION.BEESECURE">&nbsp;-&nbsp;</span><v-rating
              v-if="e.session.application == Consts.APPLICATION.BEESECURE"
              background-color="#AAAAAA"
              dense
              large
              readonly
              :value="parseInt(e.school_mark)"
            />
          </div>
          <div>
            <span
              :title="e.working_time_exceeding_reason"
              class="clock"
            ><v-icon :class="{exceeded: parseFloat(e.working_time) > (e.session.dates.reduce((acc, e) => acc += parseFloat(e.total_time), 0))}">mdi-clock-time-five-outline</v-icon><span>{{ (""+e.working_time).replace('.',',') }}h</span></span>
          </div>
        </v-card-title>
        <div class="ref">
          <router-link :to="{name: 'sessions-show-trainer-evals', params: {id: e.session.id}}">
            #{{ e.session.reference }}
          </router-link>
        </div>
        <readonly-field
          v-for="f in e.fields"
          :key="f.id"
          :field="f"
        />
      </v-card>
    </div>
    <div
      v-else
      layout="row"
      layout-align="center center"
      class="text-xs-center pa-4 white"
      style="width: 100%"
    >
      There is no evaluation yet
    </div>
    <div
      v-if="evaluations && evaluations.length"
      layout="row"
      layout-align="center center"
      style="width: 100%"
      class="text-xs-center pa-3"
    >
      <v-pagination
        v-model="page"
        :length="total"
        :total-visible="7"
      />
    </div>
  </div>
</template>


<script>
  import Organizations from '@/api/organizations'
  import dateMixin from '@/mixins/date'
  import Consts from '@/consts'
  import ReadonlyField from '@/components/sessions/evals/GenericForm/ReadonlyField.vue'

  export default {
    components: {ReadonlyField},
    mixins: [dateMixin],
    props: {
        organization: {
            type: Object,
            required: true
        },
    },

    data() {
      return {
        evaluations: [],
        sortBy: 'created_at',
        descending: true,
        page: 1,
        rowsPerPage: 6,
        total: 1,
        Consts
      }
    },

    watch: {
      page () {
        this.fetch();
      },
    },

    mounted() {
      this.fetch();
    },

    methods: {
      fetch () {
        Organizations.getEvals(this.$route.params.id, {page: this.page, rowsPerPage: this.rowsPerPage, sortBy: this.sortBy, descending: this.descending}).then(res => {
          this.evaluations = res.data.items;
          this.total = Math.ceil(res.data.total / this.rowsPerPage);
        });
      }
    }
  }
</script>

<style scoped lang="sass">
  .flexible
    display: flex
    flex-direction: row
    flex-wrap: wrap

    .card-a-puce
      margin: 5px 10px
      min-width: 400px

  .eval-title
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center

    .name
      display: flex
      align-items: center

  .exceeded
    color: tomato

  .clock
    display: flex
    align-items: center

  .ref
    padding-left: 15px
    margin-top: -10px
    margin-bottom: 10px
</style>
